import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function ClassTeachingDetails({ cls, classId }) {
  const [loaded, setLoaded] = useState(null);
  useEffect(() => {
    setLoaded(null);
    if (cls || !classId) return;
    const controller = new AbortController();
    api.get(`/classes/${classId}`, { signal: controller.signal }).then(r => setLoaded(r.data)).catch(() => {});
    return () => controller.abort();
  }, [cls, classId]);
  const data = cls || loaded;
  if (!data) return null;
  const location = data.location_address;
  const address = location && [location.address_line1, location.address_line2, location.city, location.region, location.postal_code, location.country].filter(Boolean).join(", ");
  if (!address && !data.room && !data.notes) return null;
  return <span className="my-2 block space-y-1 text-sm text-[var(--text-secondary)]" data-testid="class-teaching-details">
    {address && <span className="block">{address}</span>}
    {data.room && <span className="block">Room: {data.room}</span>}
    {data.notes && <span className="block whitespace-pre-wrap">{data.notes}</span>}
  </span>;
}
